"use client";

import { c as _c } from "react/compiler-runtime";
import DropDownMenu from 'src/components/menu/DropDownMenu';
import MainMenuButton from 'src/components/menu/MainMenuButton';
import Search from 'src/components/search/Search';
import type { IMenuAction } from 'src/components/menu/IMenuAction';
import type { IMenuItem } from 'src/lib/types/Settings';
import dynamic from "next/dynamic";
import { useEffect, useId, useReducer } from 'react';
import SearchResult from "src/components/menu/SearchResult";
import { usePathname } from "next/navigation";
const DynamicLoginButton = dynamic(() => import('src/components/menu/LoginButton').then(mod => mod.default), {
  ssr: false
});
const DynamicFilmwebIdDropDownMenu = dynamic(() => import("src/components/menu/FilmwebIdDropDownMenu").then(mod => mod.default), {
  ssr: false
});

//#region [Styles]

//#endregion

//#region [Props]
type SearchAndDropdownMenuProps = {
  menuData?: IMenuItem[];
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
export default function SearchAndDropdownMenu(t0) {
  const $ = _c(39);
  const {
    menuData,
    forceHardlinks: t1
  } = t0;
  const forceHardlinks = t1 === undefined ? false : t1;
  const [state, dispatch] = useReducer(menuReducer, EMPTY_STATE);
  const pathname = usePathname();
  const mainMenuId = useId();
  const filmwebIdMenuId = useId();
  let t2;
  if ($[0] !== pathname) {
    t2 = pathname?.indexOf("/experimental") ?? -1;
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isExperimental = t2 !== -1;
  let t3;
  if ($[2] !== pathname) {
    t3 = pathname?.indexOf("/experimental2") ?? -1;
    $[2] = pathname;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isExperimental2 = t3 !== -1;
  let t4;
  if ($[4] !== pathname) {
    t4 = pathname?.indexOf("/experimental3") ?? -1;
    $[4] = pathname;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isExperimental3 = t4 !== -1;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      dispatch({
        type: "CLEAR_SEARCH"
      });
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== pathname) {
    t6 = [pathname];
    $[7] = pathname;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== state.searchExpression || $[10] !== state.showSearchResults) {
    t7 = <Search showSearchResults={state.showSearchResults} dispatch={dispatch} searchExpression={state.searchExpression} />;
    $[9] = state.searchExpression;
    $[10] = state.showSearchResults;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isExperimental || isExperimental2 || isExperimental3;
  const t9 = isExperimental2 ? 2 : process.env.NEXT_PUBLIC_SEARCH_CUSTOM_SORT;
  let t10;
  if ($[12] !== forceHardlinks || $[13] !== state.searchExpression || $[14] !== state.showSearchResults || $[15] !== t8 || $[16] !== t9) {
    t10 = <SearchResult searchExpression={state.searchExpression} showSearchResult={state.showSearchResults} azShowScore={t8} customSortNum={t9} forceHardlinks={forceHardlinks} />;
    $[12] = forceHardlinks;
    $[13] = state.searchExpression;
    $[14] = state.showSearchResults;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => dispatch({
      type: "TOGGLE_FILMID_MENU"
    });
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== filmwebIdMenuId) {
    t12 = <DynamicLoginButton onClickIfAuthenticated={t11} popoverTarget={filmwebIdMenuId} />;
    $[19] = filmwebIdMenuId;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== mainMenuId) {
    t13 = <MainMenuButton dispatch={dispatch} popoverTarget={mainMenuId} />;
    $[21] = mainMenuId;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => dispatch({
      type: "HIDE_MENU"
    });
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== forceHardlinks || $[25] !== mainMenuId || $[26] !== menuData || $[27] !== state.showDropdownmenu) {
    t15 = <DropDownMenu id={mainMenuId} menuItems={menuData} isVisible={state.showDropdownmenu} onBrowserClose={t14} forceHardlinks={forceHardlinks} />;
    $[24] = forceHardlinks;
    $[25] = mainMenuId;
    $[26] = menuData;
    $[27] = state.showDropdownmenu;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== filmwebIdMenuId || $[30] !== state.showFilmIdMenu) {
    t16 = <DynamicFilmwebIdDropDownMenu id={filmwebIdMenuId} dispatch={dispatch} isVisible={state.showFilmIdMenu} />;
    $[29] = filmwebIdMenuId;
    $[30] = state.showFilmIdMenu;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t13 || $[35] !== t15 || $[36] !== t16 || $[37] !== t7) {
    t17 = <>{t7}{t10}{t12}{t13}{t15}{t16}</>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
    $[35] = t15;
    $[36] = t16;
    $[37] = t7;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}
//#endregion

//#region [Other]
const EMPTY_STATE: IMenuState = {
  showSearchResults: false,
  showDropdownmenu: false,
  showFilmIdMenu: false,
  searchExpression: "",
  hasFiredFirstFocus: false
};
interface IMenuState {
  showSearchResults: boolean;
  showDropdownmenu: boolean;
  showFilmIdMenu: boolean;
  searchExpression: string;
  hasFiredFirstFocus: boolean;
}
function menuReducer(state: IMenuState, action: IMenuAction): IMenuState {
  switch (action.type) {
    case 'BEGIN_SEARCH':
      if (!state.hasFiredFirstFocus) {
        trackSearchStart();
      }
      return {
        ...state,
        showSearchResults: true,
        showDropdownmenu: false,
        showFilmIdMenu: false,
        hasFiredFirstFocus: true
      };
    case 'END_SEARCH':
      return {
        ...state,
        showSearchResults: false
      };
    case 'CLEAR_SEARCH':
      return {
        ...state,
        showDropdownmenu: false,
        showSearchResults: false,
        showFilmIdMenu: false,
        searchExpression: ""
      };
    case 'DO_SEARCH':
      return {
        ...state,
        searchExpression: action.searchExpression ?? "",
        showSearchResults: true,
        showDropdownmenu: false,
        showFilmIdMenu: false
      };
    case 'TOGGLE_MENU':
      if (state.showDropdownmenu) {
        return {
          ...state,
          showSearchResults: false,
          showDropdownmenu: false,
          showFilmIdMenu: false
        };
      } else {
        trackMenuOpen();
        return {
          ...state,
          showSearchResults: false,
          showDropdownmenu: true,
          showFilmIdMenu: false
        };
      }
    case 'TOGGLE_FILMID_MENU':
      return {
        ...state,
        showFilmIdMenu: !state.showFilmIdMenu,
        showDropdownmenu: false,
        showSearchResults: false
      };
    case 'CLOSE_MENU':
      return {
        ...state,
        showSearchResults: false,
        showDropdownmenu: false,
        searchExpression: ""
      };
    case 'HIDE_MENU':
      return state.showDropdownmenu ? {
        ...state,
        showDropdownmenu: false
      } : state;
    case 'HIDE_FILMID_MENU':
      return state.showFilmIdMenu ? {
        ...state,
        showFilmIdMenu: false
      } : state;
    default:
      return state;
  }
}
function trackMenuOpen() {
  if (typeof window !== "undefined") {
    window.dataLayer?.push({
      'event': 'fw_Menu',
      'eventCategory': 'Meny',
      'eventAction': "Open"
    });
  }
}
function trackSearchStart() {
  if (typeof window !== "undefined") {
    window.dataLayer?.push({
      'event': 'fw_Quicksearch',
      'eventCategory': 'Hurtigsøk',
      'eventAction': 'Start hurtigsøk'
    });
  }
}
//#endregion